// Copyright (c) 2022 Proto Labs, Inc. All Rights Reserved.

/// <reference types="@types/segment-analytics" />

import i18n from '@/i18n';
import { LinkLanguages } from '@/models/constants';
import { HeaderLink, LinkLanguage } from '@/models/models';

const category = 'PL2 Client Side Identity';

class Analytics {
    get gaClientId(): string {
        let id = '';
        if (window.ga) {
            window.ga((tracker: any) => {
                id = tracker.get('clientId');
            });
        }
        return id;
    }

    identify(): void {
        window?.analytics?.identify({
            ecomLanguage: i18n.global.locale,
        });
    }

    page(name: string): void {
        window?.analytics?.page(name, {
            category: category,
            gaClientId: this.gaClientId,
        });
    }

    track(eventName: string, props: any): void {
        const gaClientId: string = this.gaClientId;
        window?.analytics?.track(eventName, {
            ...props,
            category: category,
            gaClientId: gaClientId,
        });
    }

    getHeaderLinks(pageName: string, uri = 'identity.protolabs.com'): HeaderLink[] {
        const result = LinkLanguages.map((l: LinkLanguage) => new HeaderLink({rel: 'alternate', href: `https://${uri}/${pageName}?lang=${l.queryStringLang}`, hrefLang: l.hrefLang }));
        return result;
    }
}

const analytics = new Analytics();
export default analytics;
